import './styles/app.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import {BrowserRouter as Router, Switch, Route} from 'react-router-dom'

import 'react-bootstrap';

import React from 'react'
import About from './pages/about';
import Home from './pages/home';
import Contact from './pages/contact-us';
import Services from './pages/services';
import NetworkService from './pages/sub-pages/network';
import SourcingService from './pages/sub-pages/sourcing';
import ComputingService from './pages/sub-pages/computing';
import ServerService from './pages/sub-pages/server';
import WebsiteService from './pages/sub-pages/websites'
import ServiceDesk from './pages/sub-pages/service';

import {NavigationHeader} from './components/nav'
import Footer from './components/footer';

import { library } from '@fortawesome/fontawesome-svg-core'
import { faHome, faPhone, faEnvelopeOpenText } from '@fortawesome/free-solid-svg-icons'

library.add(faHome, faPhone, faEnvelopeOpenText)

function App() { 

  return (
    <div className="app">        
        <Router>         
          <div className="app_content">
            <NavigationHeader/>
            <div >
              <Switch >
                <Route path="/home" exact component={Home}/>           
                <Route path="/about" exact component={About}/>
                <Route path="/services" exact component={Services}/> 
                <Route path="/services/network-and-infrastructure" exact component={NetworkService}/> 
                <Route path="/services/sourcing-and-supply-chain" exact component={SourcingService}/> 
                <Route path="/services/client-computing-management" exact component={ComputingService}/> 
                <Route path="/services/server-infrastructure-implementation" exact component={ServerService}/> 
                <Route path="/services/website-email-services" exact component={WebsiteService}/> 
                <Route path="/services/service-desk-management" exact component={ServiceDesk}/> 
                <Route path="/contact-us" exact component={Contact}/>  
                <Route path="/" component={Home}/>      
              </Switch>  
            </div>
             
          </div>
                
        </Router>  

        <Footer/>   
    </div>
  );
}

export default App;
